// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NhXA7","fullView":"styles_fullView__2dN3Y"};